var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "border-bottom": "1px solid #e3e3e3" } },
    [
      _c(
        "label",
        {
          staticClass: "fntP",
          class: _vm.isLeft ? "NCACroa_cont01_file01" : "NCACroa_cont01_file02",
          style: _vm.blockLabel ? { display: "block" } : null
        },
        [
          _c(
            "em",
            {
              staticClass: "disIb",
              class: _vm.isLeft ? (_vm.showAlert ? "padBS" : null) : "moOnly"
            },
            [
              _vm._v(_vm._s(_vm.question.title) + " "),
              _c("span", { staticClass: "ico-must-astar" })
            ]
          ),
          _vm._v(" "),
          _vm._t("inner"),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "NCACroa_fileBtn",
              class: _vm.disabled || _vm.existFileData ? "disabled" : null,
              style: [
                _vm.hideBtn ? { display: "none" } : null,
                _vm.disabled || _vm.existFileData ? null : { cursor: "pointer" }
              ],
              on: { click: _vm.clickFileUpload }
            },
            [_vm._v("파일 업로드")]
          )
        ],
        2
      ),
      _vm._v(" "),
      !_vm.existFileData
        ? _c("input", {
            ref: "attachment",
            staticStyle: { display: "none" },
            attrs: {
              type: "file",
              accept: ".png, .jpg, .pdf",
              name: "NCACroa_file_" + _vm.question.sq_code
            },
            on: { change: _vm.addAttachment }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "posRe",
          style: _vm.hideBtn ? { display: "none" } : null
        },
        [
          _c(
            "label",
            {
              staticClass: "NCACroa_cont01_file01 marTS NCAfile_remove",
              on: { click: _vm.downloadFile }
            },
            [
              _c("input", {
                staticClass: "file_download",
                style: _vm.existFileData ? { cursor: "pointer" } : null,
                attrs: {
                  type: "text",
                  title: _vm.data.original_name,
                  disabled: ""
                },
                domProps: { value: _vm.data.original_name }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "posAb",
              staticStyle: { right: "0", top: "6px", background: "none" },
              style: !_vm.existFileData ? { display: "none" } : null,
              on: { click: _vm.deleteAttachment }
            },
            [
              _c("img", {
                attrs: {
                  src: require("../images/btn_close.png"),
                  alt: "파일 삭제 버튼"
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm._t("outer")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4682780a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4682780a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey/components/SurveyAttachment.vue
// module id = null
// module chunks = 